import React, { useContext } from "react";

/// React router dom
import { Switch, Route } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import OrderPage from "./components/Dashboard/OrderPage";
import OrderDetails from "./components/Dashboard/OrderDetails";
import CustomersPage from "./components/Dashboard/Customers";
import Analytics from "./components/Dashboard/Analytics";
import Review from "./components/Dashboard/Review";
import Task from "./components/Dashboard/Task";


/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

// Managment List

import CustomerManagment from "./components/AppsMenu/MasterManagment/CustomerManagment";
import DeliveryStaffManagment from "./components/AppsMenu/MasterManagment/DeliveryStaffManagment";
import AdminManagment from "./components/AppsMenu/MasterManagment/AdminManagment";
import CustomerStaffManagment from "./components/AppsMenu/MasterManagment/CustomerStaffManagment";
import ManagerMasterList from "./components/AppsMenu/MasterManagment/ManagerMasterList";
import StaffMasterList from "./components/AppsMenu/MasterManagment/StaffMasterList";
import OwnerMasterList from "./components/AppsMenu/MasterManagment/OwnerMasterList";

//General management
import UserLogManagement from "./components/AppsMenu/MasterManagment/UserLogManagement";
import OrderLogManagement from "./components/AppsMenu/MasterManagment/OrderLogManagement";
import RoleManagement from "./components/AppsMenu/MasterManagment/RoleManagement";

//payments methods
import ManagePaymentMethods from "./components/AppsMenu/MasterManagment/ManagePaymentMethods";
import OutletPaymentmethods from "./components/AppsMenu/MasterManagment/OutletPaymentmethods";
import EcommerceMnt from "./components/AppsMenu/MasterManagment/EcommerMnagement/EcommerceMnt";
import Card from "./components/AppsMenu/MasterManagment/EcommerMnagement/Cart";
import OutletIndividualStafs from "./components/AppsMenu/MasterManagment/OutletIndividualStafs";
import SuperAdminDashboard from "./components/AppsMenu/MasterManagment/SuperAdminDashboard";
import PwdChange from "./components/AppsMenu/MasterManagment/OutletstaffMnt";
import OutletManagment from "./components/AppsMenu/MasterManagment/OutletManagment";
import FoodMenuManagment from "./components/AppsMenu/MasterManagment/FoodMenuManagment";
import TMPFoodMenuManagment from "./components/AppsMenu/MasterManagment/TMPFoodMenuManagment";
import OutletFoodMenuListManagment from "./components/AppsMenu/MasterManagment/OutletFoodMenuListManagment";
import MenuCategory from "./components/AppsMenu/MasterManagment/MenuCategory";

import MenuSubMenuCategory from "./components/AppsMenu/MasterManagment/MenuSubMenuCategory";
import OutletMenuPlanner from "./components/AppsMenu/MasterManagment/OrderManagment/OutletMenuPlanner";

import Campaign_Service from "./components/AppsMenu/MasterManagment/BoradCast_Campaign/Campaign_Service";

import CustomerList from "./components/AppsMenu/MasterManagment/CustomerList";
import OrderList from "./components/AppsMenu/MasterManagment/OrderList";

import SubscriptionItemMaster from "./components/AppsMenu/MasterManagment/SubscriptionItemMaster";
import SubscribersMaster from "./components/AppsMenu/MasterManagment/SubscribersMaster";
import RestarantsMaster from "./components/AppsMenu/MasterManagment/RestarantsMaster";
import DeliveryPointMaster from "./components/AppsMenu/MasterManagment/DeliveryPointMaster";
import Deliveryslot from "./components/AppsMenu/MasterManagment/Deliveryslot";
import WalletMaster from "./components/AppsMenu/MasterManagment/WalletMaster";
import SubscriptionReports from "./components/AppsMenu/MasterManagment/SubscriptionReports";
import Campaign from "./components/AppsMenu/MasterManagment/Campaign";
import Template_list from "./components/AppsMenu/MasterManagment/Template_list";
import CampaignSteper from "./components/AppsMenu/MasterManagment/CampaignSteper";
import TemplateService from "./components/AppsMenu/MasterManagment/TemplateService";
import TemplateServiceList from "./components/AppsMenu/MasterManagment/TemplateServiceList";
import Previewcard from "./components/AppsMenu/MasterManagment/Previewcard";

import contact_Master from "./components/AppsMenu/MasterManagment/Contact_master";

import FreeDelivery from "./components/AppsMenu/MasterManagment/FreeDelivery"
import DailyPlanner from "./components/AppsMenu/MasterManagment/DailyPlanner"
import OrderManagment from "./components/AppsMenu/MasterManagment/OrderManagment/OrderManagment";
import SlotMasterManagment from "./components/AppsMenu/MasterManagment/SlotMasterManagment";
import MenuAvailablity from "./components/AppsMenu/MasterManagment/MenuAvailablity";
// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import Chartist from "./components/charts/chartist";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiMediaObject from "./components/bootstrap/MediaObject";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import Nestable from "./components/PluginsMenu/Nestable/Nestable";
import MainNouiSlider from "./components/PluginsMenu/Noui Slider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/Sweet Alert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/Jqv Map/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

//Redux
import Todo from "./pages/Todo";
import ReduxForm from "./components/Forms/ReduxForm/ReduxForm";
import WizardForm from "./components/Forms/ReduxWizard/Index";

/// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import SummerNote from "./components/Forms/Summernote/SummerNote";
import Pickers from "./components/Forms/Pickers/Pickers";
import jQueryValidation from "./components/Forms/jQueryValidation/jQueryValidation";

/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";


const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const routes = [
    /// Dashboard

    // { url: "", component: Home },

    { url: "dashboard", component: Home },
    { url: "dashboard-dark", component: DashboardDark },
    { url: "order-list", component: OrderPage },
    { url: "order-details", component: OrderDetails },
    { url: "customers", component: CustomersPage },
    { url: "analytics", component: Analytics },
    { url: "review", component: Review },

    { url: "task", component: Task },

    /// Apps
    
    { url: "app-profile", component: AppProfile },
    { url: "CustomerManagment", component: CustomerManagment },
    { url: "DeliveryStaffManagment", component: DeliveryStaffManagment },
    { url: "AdminManagment", component: AdminManagment },
    { url: "OwnerMasterList", component: OwnerMasterList },
    { url: "ManagerMasterList", component: ManagerMasterList },
    { url: "StaffMasterList", component: StaffMasterList },
    { url: "CustomerStaffManagment", component: CustomerStaffManagment },
    { url: "EcommerceMnt", component: EcommerceMnt },
    { url: "cart", component: Card },
    { url: "UserLogManagement", component: UserLogManagement },
    { url: "OrderLogManagement", component: OrderLogManagement },
    { url: "RoleManagement", component: RoleManagement },
    { url: "Campaign", component: Campaign },
    { url: "Template_list", component: Template_list },
    { url: "TemplateServiceList", component: TemplateServiceList },
    { url: "contact_Master", component:contact_Master },
    { url: "CampaignSteper", component: CampaignSteper },
    
    { url: "Campaign_Service", component: Campaign_Service },
    { url: "TemplateService", component: TemplateService },
    { url: "Previewcard", component: Previewcard }, 

    { url: "ManagePaymentMethods", component: ManagePaymentMethods },
    { url: "OutletPaymentmethods", component: OutletPaymentmethods },
    { url: "SuperAdminDashboard", component: SuperAdminDashboard },
    { url: "resetpassword", component: PwdChange },
    { url: "OutletIndividualStafs", component: OutletIndividualStafs },
    { url: "OutletManagment", component: OutletManagment },
    { url: "FoodMenuManagment", component: FoodMenuManagment },

    //Subscription
    { url: "SubscriptionItemMaster", component: SubscriptionItemMaster },
    { url: "SubscribersMaster", component: SubscribersMaster },
    { url: "RestarantsMaster", component: RestarantsMaster },
    { url: "DeliveryPointMaster", component: DeliveryPointMaster },
    { url: "Deliveryslot", component: Deliveryslot },
    { url: "WalletMaster", component: WalletMaster },
    { url: "SubscriptionReports", component: SubscriptionReports },
    { url: "FreeDelivery", component: FreeDelivery },
    { url: "DailyPlanner", component: DailyPlanner },

    { url: "FoodMenuListManagment", component: TMPFoodMenuManagment },
    { url: "OutletFoodMenuListManagment", component: OutletFoodMenuListManagment },

    { url: "MenuCategory", component: MenuCategory },
    { url: "MenuSubMenuCategory", component: MenuSubMenuCategory },
    { url: "OutletMenuPlanner", component: OutletMenuPlanner },


    { url: "CustomerList", component: CustomerList },
    { url: "OrderList", component: OrderList },
    { url: "OrderManagment", component: OrderManagment },
    { url: "SlotMasterManagment", component: SlotMasterManagment },
    { url: "MenuAvailablity", component: MenuAvailablity },

    { url: "email-compose", component: Compose },
    { url: "email-inbox", component: Inbox },
    { url: "email-read", component: Read },
    { url: "app-calender", component: Calendar },
    { url: "post-details", component: PostDetails },

    /// Chart
    { url: "chart-sparkline", component: SparklineChart },
    { url: "chart-chartjs", component: ChartJs },
    { url: "chart-chartist", component: Chartist },
    { url: "chart-apexchart", component: ApexChart },
    { url: "chart-rechart", component: RechartJs },

    /// Bootstrap
    { url: "ui-alert", component: UiAlert },
    { url: "ui-badge", component: UiBadge },
    { url: "ui-button", component: UiButton },
    { url: "ui-modal", component: UiModal },
    { url: "ui-button-group", component: UiButtonGroup },
    { url: "ui-accordion", component: UiAccordion },
    { url: "ui-list-group", component: UiListGroup },
    { url: "ui-media-object", component: UiMediaObject },
    { url: "ui-card", component: UiCards },
    { url: "ui-carousel", component: UiCarousel },
    { url: "ui-dropdown", component: UiDropDown },
    { url: "ui-popover", component: UiPopOver },
    { url: "ui-progressbar", component: UiProgressBar },
    { url: "ui-tab", component: UiTab },
    { url: "ui-pagination", component: UiPagination },
    { url: "ui-typography", component: UiTypography },
    { url: "ui-grid", component: UiGrid },

    /// Plugin
    { url: "uc-select2", component: Select2 },
    { url: "uc-nestable", component: Nestable },
    { url: "uc-noui-slider", component: MainNouiSlider },
    { url: "uc-sweetalert", component: MainSweetAlert },
    { url: "uc-toastr", component: Toastr },
    { url: "map-jqvmap", component: JqvMap },
    { url: "uc-lightgallery", component: Lightgallery },



    ///Redux
    { url: "todo", component: Todo },
    { url: "redux-form", component: ReduxForm },
    { url: "redux-wizard", component: WizardForm },

    /// Widget
    { url: "widget-basic", component: Widget },

    /// Shop
    { url: "ecom-product-grid", component: ProductGrid },
    { url: "ecom-product-list", component: ProductList },
    { url: "ecom-product-detail", component: ProductDetail },
    { url: "ecom-product-order", component: ProductOrder },
    { url: "ecom-checkout", component: Checkout },
    { url: "ecom-invoice", component: Invoice },
    { url: "ecom-product-detail", component: ProductDetail },
    { url: "ecom-customers", component: Customers },

    /// Form
    { url: "form-element", component: Element },
    { url: "form-wizard", component: Wizard },
    { url: "form-editor-summernote", component: SummerNote },
    { url: "form-pickers", component: Pickers },
    { url: "form-validation-jquery", component: jQueryValidation },

    /// table
    { url: 'table-filtering', component: FilteringTable },
    { url: 'table-sorting', component: SortingTable },
    { url: "table-datatable-basic", component: DataTable },
    { url: "table-bootstrap-basic", component: BootstrapTable },

    /// pages
    { url: "page-register", component: Registration },
    { url: "page-lock-screen", component: LockScreen },
    { url: "page-login", component: Login },
    { url: "page-forgot-password", component: ForgotPassword },
    { url: "page-error-400", component: Error400 },
    { url: "page-error-403", component: Error403 },
    { url: "page-error-404", component: Error404 },
    { url: "page-error-500", component: Error500 },
    { url: "page-error-503", component: Error503 },
  ];
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let pagePath = path.split("-").includes("page");
  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${menuToggle ? "menu-toggle" : ""
          }`}
      >
        {!pagePath && <Nav />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div className="container-fluid ovrl-tab">
          <div
            className={`${!pagePath ? "container-fluid ovrl-in-tab" : ""}`}
            // style={{ minHeight: window.screen.height - 60 }}
          >
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <Setting />
    </>
  );
};

export default Markup;
